<template>
	<div class="mb-4">
		<section class="container-actions">
			<CRow class="mb-4">
				<CCol>
					<span class="typo-label text-black-45">
						{{ $t('message.conditions') }}
					</span>
				</CCol>
				<CCol class="text-right">
					<CButton
						v-if="isAdmin"
						color="secondary"
						class="btn-new-user transparent"
						@click="openModal"
					>
						{{ $t('button.add_condition') }}
					</CButton>
				</CCol>
			</CRow>
		</section>
		<section>
			<CRow>
				<CCol v-if="list.length">
					<CRow class="container-conditions">
						<CCol lg="12" class="mb-3 typo-label">
							{{ $t('message.condition') }}
						</CCol>
						<CCol lg="12">
							<ul class="container-conditions-list">
								<li
									v-for="(item, index) in list"
									:key="index"
									class="container-conditions-list-item"
								>
									<span class="container-conditions-list-item-title">
										{{ $t('message.quantity_lower_than') }}
									</span>
									<span class="container-conditions-list-item-qty typo-label">
										{{ item.minQty }}
										{{ $t('message.qty') }}
									</span>
									<span
										class="container-conditions-list-item-edit text-black-45"
										@click="onClickEdit($event, index)"
									>
										<CIcon name="cil-pencil" />
									</span>
									<span
										v-if="!disabled"
										class="container-conditions-list-item-delete text-black-45"
										@click="openModalConfirm(index)"
									>
										<CIcon name="cil-trash" />
									</span>
								</li>
							</ul>
						</CCol>
					</CRow>
				</CCol>
				<CCol v-else>
					<BaseNoItemBanner
						:text="$t('message.there_is_no_condition_added')"
						class="empty-box"
					/>
				</CCol>
			</CRow>
			<CRow>
				<CCol
					v-if="isValid === false"
					class="mt-1"
				>
					<div class="invalid-feedback d-block">
						{{ $t('message.conditions_is_required') }}
					</div>
				</CCol>
			</CRow>
		</section>

		<!-- Modal Condition -->
		<ModalCondition
			ref="modal-condition"
			:title="$t('message.add_condition')"
			:min-qty="form.minQty"
			:channels="form.channels"
			:disabled="disabled"
			@onSubmit="handleSubmit"
		/>
		<!-- End Modal Condition -->

		<!-- Modal Confirm Delete -->
		<ModalConfirmDelete
			ref="modal-confirm-delete"
			:show.sync="modalConfirm.isShow"
			:title="$t('message.do_you_want_to_remove_this')"
			@onSubmit="handleConfirmDelete"
			@onCancel="handleCancelDelete"
		/>
		<!-- End Modal Confirm Delete -->
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import useAllocateCondition from '../use/allocateCondition';

export default {
	name: 'AllocateCondition',

	props: {
		channels: {
			type: Array,
			default: () => [],
		},
		conditions: {
			type: Array,
			default: () => [],
		},
		isValid: {
			type: Boolean,
			default: null,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},

	setup(props, context) {
		const options = {
			defaultState: {
				channels: props.channels,
				conditions: props.conditions,
			},
		};

		const {
			form,
			list,
			modalConfirm,
			openModal,
			openModalConfirm,
			handleSubmit,
			onClickEdit,
			handleConfirmDelete,
			handleCancelDelete,
		} = useAllocateCondition(props, context, options);

		return {
			form,
			list,
			modalConfirm,
			openModal,
			openModalConfirm,
			handleSubmit,
			onClickEdit,
			handleConfirmDelete,
			handleCancelDelete,
		};
	},

	computed: {
		...mapGetters('me', {
			isAdmin: 'isAdmin',
		}),
	},
};
</script>

<style lang="scss" scoped>
.container-conditions {
	background-color: $color-gray-100;
	padding: rem(16) rem(16) rem(44) rem(16);

	&-list {
		padding: 0;
		margin: 0;

		&-item {
			display: flex;
			align-items: center;
			list-style: none;
			height: rem(60);
			padding: rem(16);
			margin-bottom: rem(8);
			background-color: $color-white;
			border: solid 1px $color-gray-400;
			border-radius: 4px;

			&:last-of-type {
				margin-bottom: 0;
			}

			&-title {
				width: rem(215);
			}

			&-qty {
				flex: 1;
				text-transform: lowercase;
			}

			&-edit, &-delete {
				display: flex;
				justify-content: center;
				align-items: center;
				width: rem(40);
				height: rem(40);
				cursor: pointer;
			}
		}
	}
}
</style>